import { defineMessages } from 'react-intl';

const ASC = defineMessages({
  iconLabel: {
    id: 'frontbucket.jswTab.siteIssuesList.sortIconLabelAscending',
    description:
      'Text for the label for the descending sort direction icon in the Jira site issues list',
    defaultMessage: 'Ascending',
  },
  activeSortLabel: {
    id: 'frontbucket.jswTab.siteIssuesList.activeSortLabelAscending',
    description:
      'Text for the screen reader label when the Jira site issues list is sorted by a column in ascending order',
    defaultMessage: 'Currently sorting by {sortLabel} in ascending order',
  },
});

const DESC = defineMessages({
  iconLabel: {
    id: 'frontbucket.jswTab.siteIssuesList.sortIconLabelDescending',
    description:
      'Text for the label for the ascending sort direction icon in the Jira site issues list',
    defaultMessage: 'Descending',
  },
  activeSortLabel: {
    id: 'frontbucket.jswTab.siteIssuesList.activeSortLabelDescending',
    description:
      'Text for the screen reader label when the Jira site issues list is sorted by a column in descending order',
    defaultMessage: 'Currently sorting by {sortLabel} in descending order',
  },
});

export const sortMessages = { ASC, DESC };
